/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './consumable-order-item.reducer';

export const ConsumableOrderItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const consumableOrderItemEntity = useAppSelector(state => state.consumableOrderItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consumableOrderItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.consumableOrderItem.detail.title">ConsumableOrderItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.id}</dd>
          <dt>
            <span id="remarks">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.remarks">Remarks</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.remarks}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.quantity}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.consumableOrderItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{consumableOrderItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumableOrderItem.consumable">Consumable</Translate>
          </dt>
          <dd>{consumableOrderItemEntity.consumable ? consumableOrderItemEntity.consumable.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.consumableOrderItem.order">Order</Translate>
          </dt>
          <dd>{consumableOrderItemEntity.order ? consumableOrderItemEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/consumable-order-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/consumable-order-item/${consumableOrderItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsumableOrderItemDetail;
